'use strict';
'use strict';
var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, removeRecentSearch, removeRecentSearches, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, removeRecentSearch = ref.removeRecentSearch, removeRecentSearches = ref.removeRecentSearches, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.rerender = bind(this.rerender, this);
    this.success = bind(this.success, this);
    var flags, ref1, ref2, ref3;
    this.env = opts.env, this.endpoints = opts.endpoints, this.experiments = opts.experiments, this.$container = opts.resultList, flags = opts.options;
    this.query = '';
    this.ctx = 'search';
    this.$form = $('#ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#ls-search');
    this.$location = this.$form.find('#ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = I18n.locale, this.country = I18n.country;
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.ajaxRequest = null;
    this.buildAutocompleteListThrottle = _.throttle(((function(_this) {
      return function(e, ctx) {
        return _this.buildAutocompleteList(e, ctx);
      };
    })(this)), 500);
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    this.hasBetterUx = flags.enableBetterUx, this.hasGeolocation = flags.enableGeoLocation, this.hasSearchCategories = flags.enableSearchCategories, this.fetchWithPlacesApi = flags.fetchWithPlacesApi;
    if (flags.enableRecentSearches) {
      this.getRecentSearches();
    }
    if (flags.enableRecentLocations) {
      this.getRecentLocations();
    }
    if ((ref3 = Groupon.LS) != null ? ref3.hasTouch : void 0) {
      this.setBHViewport();
    }
    this.bind();
  }

  Typeahead.prototype.bind = function() {
    this.$container.on('click', '.tw-item .tw-clear', (function(_this) {
      return function(e) {
        var $item, ctx, value;
        e.preventDefault();
        e.stopImmediatePropagation();
        $item = $(e.currentTarget).siblings('.tw-link');
        if (!(value = $item.attr('data-value'))) {
          return;
        }
        ctx = _this.ctx;
        removeRecentSearch(value, ctx);
        _this.rerender(e, ctx);
      };
    })(this));
    this.$container.on('click', '.tw-heading .tw-clear', (function(_this) {
      return function(e) {
        var ctx;
        ctx = _this.ctx;
        removeRecentSearches(ctx);
        _this.rerender(e, ctx);
      };
    })(this));
  };

  Typeahead.prototype.enableLocationPlacesAPI = function(e) {
    return this.fetchWithPlacesApi = true;
  };

  Typeahead.prototype.checkIfQuery = function(query) {
    if ((query != null ? query.length : void 0) < 3 || !/[a-z]/gi.test(query)) {
      return false;
    }
    return true;
  };


  /**
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ajaxConfig, ajaxData, cookie, isAddressesAutocomplete, lat, lng, ref1, ref2, ref3, ref4, ref5, successHandle, url;
    if ($('.ls-error-dialog').length) {
      return;
    }
    this.query = query;
    isAddressesAutocomplete = this.fetchWithPlacesApi && this.ctx === 'location';
    if (isAddressesAutocomplete && !this.checkIfQuery(query)) {
      this.success({
        locationsAutocompleteResults: []
      });
      return;
    }
    ajaxData = {
      input: query,
      limit: 10
    };
    if (this.ctx === 'location') {
      if ((cookie = Cookie.get('cll') || Cookie.get('ell')) != null) {
        ref1 = cookie.split(','), lat = ref1[0], lng = ref1[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
      Object.assign(ajaxData, {
        lat: lat,
        lng: lng
      });
    }
    if (isAddressesAutocomplete) {
      url = [(ref2 = Groupon.endpoints) != null ? ref2.places_autocomplete : void 0, 'v1'].join('/');
      Object.assign(ajaxData, {
        division: ((ref3 = Groupon.division) != null ? ref3.id : void 0) || ''
      });
      successHandle = (function(_this) {
        return function(arg) {
          var data, err;
          data = arg.data, err = arg.err;
          if (err) {
            return _this.reset();
          }
          return _this.success({
            locationsAutocompleteResults: data.addressesAutocompleteResults
          });
        };
      })(this);
    } else {
      url = [(ref4 = Groupon.endpoints) != null ? ref4.autocomplete : void 0, this.ctx, 'v1'].join('/');
      successHandle = (function(_this) {
        return function(arg) {
          var data, err;
          data = arg.data, err = arg.err;
          if (err) {
            return _this.reset();
          }
          return _this.success(data);
        };
      })(this);
    }
    ajaxConfig = {
      url: url,
      headers: {
        'x-ls-client-req': true,
        'x-ls-locale': I18n.locale
      },
      data: ajaxData,
      success: successHandle,
      error: (function(_this) {
        return function() {
          return _this.reset;
        };
      })(this)
    };
    if ((ref5 = this.ajaxRequest) != null) {
      ref5.abort();
    }
    this.ajaxRequest = $.ajax(ajaxConfig);
  };


  /**
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    this.ajaxRequest = null;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /**
   * Generate typeahead html and append to typeahead container
   *
   * @param   {Array}   collections - Updated
   * @param   {String}  query
   * @returns {Boolean}             - State whether a collection is rendered
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, isRendered, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return false;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query, {
      experiments: this.experiments,
      env: this.env
    }), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if ((isRendered = !!(list != null ? list.length : void 0))) {
      list.unshift("<ul id='autocomplete-list' role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          this.$search.removeAttr('aria-busy');
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
          this.$location.removeAttr('aria-busy');
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw);
      moveAutocomplete($container, this.ctx, this.env);
      $container.show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
      isRendered = false;
    }
    return isRendered;
  };

  Typeahead.prototype.rerender = function(e, ctx) {
    switch (ctx) {
      case 'search':
        this.getRecentSearches();
        if (e != null) {
          e.currentTarget.id = 'ls-search';
        }
        break;
      case 'location':
        this.getRecentLocations();
        if (e != null) {
          e.currentTarget.id = 'ls-location';
        }
    }
    this.buildAutocompleteList(e, ctx);
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };

  Typeahead.prototype.enableRecentLocations = function(e) {
    this.getRecentLocations();
    return this.rerender(e, 'location');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.ajaxRequest = null;
    this.$container.find('ul').empty();
    ax.hide(this.$container);
    this.$inputs.removeAttr('aria-activedescendant').attr('aria-busy', 'true');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty().html('<ul id="autocomplete-list" role="list" aria-busy="true"></ul>');
  };


  /**
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @public
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var hasRendered, id, query, ref1, ref2;
    if (e != null) {
      e.preventDefault();
    }
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = (query != null ? query.trim() : void 0) || '';
    }
    if (!query) {
      if ((ref2 = this.ajaxRequest) != null) {
        ref2.abort();
      }
      this.reset();
      hasRendered = (function() {
        switch (id) {
          case 'ls-search':
            return this.showDealWidget();
          case 'ls-location':
            return this.showLocationWidget();
          default:
            return false;
        }
      }).call(this);
      if (!hasRendered && this.env === 'desktop') {
        this.$container.hide();
      }
    } else {
      switch (e.type) {
        case 'input':
          if (query !== this.query) {
            this.fetch(query);
          }
          break;
        default:
          this.fetch(query);
      }
    }
  };

  Typeahead.prototype.getRecentSearches = function() {
    var ref1;
    this.recentKeywords = getRecentSearches('deal');
    return this.hasRecentSearches = ((ref1 = this.recentKeywords) != null ? ref1.length : void 0) > 0;
  };

  Typeahead.prototype.getRecentLocations = function() {
    var locations, ref1;
    locations = getRecentSearches('location');
    this.recentLocations = locations.filter(function(e) {
      return e.hasOwnProperty('division');
    });
    if (((ref1 = this.recentLocations) != null ? ref1.length : void 0) > 0) {
      if (this.recentLocations.length !== locations.length) {
        setRecentSearches(this.recentLocations, 'location');
      }
      if (typeof this.recentLocations[0] === 'object') {
        return this.hasRecentLocations = true;
      } else {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem('LS_recentLocations') : void 0;
      }
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /**
   * Build configurable collections for deal typeahead when input is empty
   *
   * @returns {boolean} - State whether a collection is being rendered
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    collections = [];
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
    }
    return this.buildView(collections);
  };


  /**
   * Build configurable collections for location typeahead when input is empty
   *
   * @returns {boolean} - State whether a collection is being rendered
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    collections = [];
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
    }
    return this.buildView(collections);
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

Object.assign(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});

